import report from '@/api/report/daily'

import { baseState, baseMutations } from '@/store/mixins'
import moment from 'moment'

export const state = {
  ...baseState,
  date_from: moment().format('DD-MM-YYYY'),
  date_to: moment().format('DD-MM-YYYY')
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_DATE_FROM(state, date) {
    state.date_from = date
  },
  SET_DATE_TO(state, date) {
    state.date_to = date
  }
}

export const actions = {
  user(context) {
    return report.user()
  },
  seller(context, attributes = {}) {
    return report.seller({ params: attributes })
  },
  category(context) {
    return report.category()
  },
  productGroup(context, Options = {}) {
    return report.productGroup({ params: Options })
  },
  productQuery(context, Options = {}) {
    return report.productQuery({ params: Options })
  },
  saleItem(context, data) {
    return report.saleItem(data)
  },
  saleItemExcel(context, data) {
    return report.saleItemExcel(data)
  },
  store(context, data) {
    return report.income(data)
  },
  incomeExcel(context, data) {
    return report.incomeExcel(data)
  },
  // generate income by sale
  incomeBySale(context, attributes = {}) {
    return report.incomeBySale({ params: attributes })
  },
  // generate cash flow and stock control list
  cashFlowAndStockControl(context, attributes = {}) {
    return report.cashFlowAndStockControl({
      params: Object.assign(
        {
          date_from: context.state.date_from,
          date_to: context.state.date_to
        },
        attributes
      )
    })
  }
}
